import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "64",
  height: "64",
  viewBox: "0 0 64 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M2 20.6257V59C2 60.6569 3.34315 62 5 62H59C60.6569 62 62 60.6569 62 59V20.6257M2 20.6257L14.6316 29.852M2 20.6257V18.8539C2 17.6664 2.70041 16.5907 3.78636 16.1103L14.6316 11.3129M62 20.6257L50.9474 29.7078M62 20.6257V18.7455C62 17.614 61.3633 16.5787 60.3535 16.0682L50.9474 11.3129M50.9474 11.3129V5.00002C50.9474 3.34317 49.6042 2.00003 47.9474 2.00003H17.6316C15.9747 2.00003 14.6316 3.34317 14.6316 5.00003V11.3129M50.9474 11.3129V29.7078M14.6316 11.3129V29.852M50.9474 29.7078L33.5556 39.7382C32.5978 40.2906 31.4137 40.2713 30.4744 39.6881L14.6316 29.852M22.5263 24.3508H35.1579M22.5263 11.3129H41.4737",
      stroke: "#219653",
      "stroke-width": "4",
      "stroke-linecap": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }